import { Button } from '@/components/ui/button';
import { Share2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { toast } from 'sonner';

export default function ShareEventButton({ event, variant = "default", size = "default" }) {
  // Use share endpoint for WhatsApp to get rich preview
  const shareUrl = `${window.location.origin}/events/${event.id}/public/share`;
  const eventUrl = `${window.location.origin}/events/${event.id}/public`;
  
  // Format date for sharing
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // WhatsApp sharing with rich preview
  const shareViaWhatsApp = () => {
    const eventTypeEmoji = {
      'in_person': '📍',
      'online': '🌐',
      'hybrid': '🔄'
    };
    
    const emoji = eventTypeEmoji[event.event_type] || '🎉';
    
    // Simple message with share URL that has meta tags
    let message = `${emoji} *${event.title}*\n\n`;
    message += `📅 ${formatDate(event.start_date)}\n`;
    message += `📍 ${event.location}\n\n`;
    
    if (event.description) {
      const shortDesc = event.description.length > 100 
        ? event.description.substring(0, 100) + '...' 
        : event.description;
      message += `${shortDesc}\n\n`;
    }
    
    message += `🎟️ Vedi evento e acquista biglietti:\n${shareUrl}`;
    
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  // Copy link to clipboard
  const copyLink = () => {
    navigator.clipboard.writeText(eventUrl);
    toast.success('Link copiato negli appunti!');
  };

  // Share via email
  const shareViaEmail = () => {
    const subject = encodeURIComponent(`Ti invito a: ${event.title}`);
    let body = `Ciao!\n\nTi invito all'evento:\n\n`;
    body += `🎉 ${event.title}\n`;
    body += `📅 ${formatDate(event.start_date)}\n`;
    body += `📍 ${event.location}\n\n`;
    
    if (event.description) {
      body += `${event.description}\n\n`;
    }
    
    body += `Acquista il tuo biglietto qui:\n${eventUrl}\n\n`;
    body += `Ci vediamo lì!`;
    
    window.location.href = `mailto:?subject=${subject}&body=${encodeURIComponent(body)}`;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className="gap-2">
          <Share2 className="w-4 h-4" />
          Condividi Evento
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={shareViaWhatsApp} className="gap-3 cursor-pointer">
          <span className="text-2xl">📱</span>
          <div>
            <p className="font-medium">WhatsApp</p>
            <p className="text-xs text-gray-500">Condividi con immagine e descrizione</p>
          </div>
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={shareViaEmail} className="gap-3 cursor-pointer">
          <span className="text-2xl">📧</span>
          <div>
            <p className="font-medium">Email</p>
            <p className="text-xs text-gray-500">Invia invito via email</p>
          </div>
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={copyLink} className="gap-3 cursor-pointer">
          <span className="text-2xl">🔗</span>
          <div>
            <p className="font-medium">Copia Link</p>
            <p className="text-xs text-gray-500">Incolla dove vuoi</p>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
